<template>
  <span @click="onClick">
    <slot name="trigger"></slot>
  </span>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "Warning!"
    },

    message: {
      type: String
    },

    type: {
      type: String,
      default: "is-warning"
    },

    confirmText: {
      type: String,
      default: "Confirm"
    },

    hasIcon: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onClick() {
      this.$buefy.dialog.confirm({
        title: this.title,
        message: this.message,
        type: this.type,
        confirmText: this.confirmText,
        cancelText: "Cancel",
        hasIcon: this.hasIcon,
        onConfirm: () => this.$emit("confirmed")
      });
    }
  }
};
</script>
